import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=88f6623a"
import script from "./Informacion.vue?vue&type=script&lang=ts"
export * from "./Informacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports